import { ApiKey } from './api-key.model'

export enum DeviceType {
  Reaper = 'reaper',
  Importer = 'importer'
}

export interface Device {
  _id: string
  api_keys: ApiKey[]
  errors: string[]
  info: {
    [key: string]: string
  }
  interval: number
  key: string
  label: string
  last_seen: string
  name: string
  type: DeviceType
  version: string
  disabled: boolean
  storage_config: StorageConfig
}

export interface DeviceUpdate {
  disabled?: boolean
  storage_config?: StorageConfig
}

export interface StorageConfig {
  storage_strategy: 'site' | 'project' | 'custom'
  provider?: string
}
